import React from "react";

import Welcome from "./content";

const WelcomePage = () => {
	return <Welcome/>;
};

export default WelcomePage;
